var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92608 50.0002C13.4792 50.0002 17.1744 46.2668 17.1744 41.6668V33.3335H8.92608C4.373 33.3335 0.677734 37.0668 0.677734 41.6668C0.677734 46.2668 4.373 50.0002 8.92608 50.0002Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.677734 24.9998C0.677734 20.3998 4.373 16.6665 8.92608 16.6665H17.1744V33.3332H8.92608C4.373 33.3332 0.677734 29.5998 0.677734 24.9998Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.677734 8.33333C0.677734 3.73333 4.373 0 8.92608 0H17.1744V16.6667H8.92608C4.373 16.6667 0.677734 12.9333 0.677734 8.33333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1738 0H25.4222C29.9753 0 33.6705 3.73333 33.6705 8.33333C33.6705 12.9333 29.9753 16.6667 25.4222 16.6667H17.1738V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6705 25.0001C33.6705 29.6001 29.9753 33.3334 25.4222 33.3334C20.8691 33.3334 17.1738 29.6001 17.1738 25.0001C17.1738 20.4001 20.8691 16.6667 25.4222 16.6667C29.9753 16.6667 33.6705 20.4001 33.6705 25.0001Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 50,
    fill: "white",
    transform: "translate(0.673828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.edc9d7d5822981931678cfe9b86cc557.svg";
export { ForwardRef as ReactComponent };